export enum SupportCategoryEnum {
  ALL = 'ALL',
  CUSTOMER = 'CUSTOMER',
  USER = 'USER',
  TRANSACTION = 'TRANSACTION',
}

export const optionsSupportSelect = [
  { value: SupportCategoryEnum.ALL, label: 'Todos' },
  { value: SupportCategoryEnum.CUSTOMER, label: 'Cliente' },
  { value: SupportCategoryEnum.USER, label: 'Vendedor' },
  { value: SupportCategoryEnum.TRANSACTION, label: 'Proposta' },
]
